/**
 * Logs estructurados en consola para depurar red / checkout / menú (sin PII en payload).
 * @param {string} tag — ej. 'network', 'checkout', 'menu'
 * @param {Record<string, unknown>} payload
 */
export function logStructured(tag, payload) {
  try {
    console.warn(`[soluqr:${tag}]`, payload);
  } catch {
    /* ignore */
  }
}
